<template>

    <div>


        <v-toolbar flat color="white" v-if="error">
            <v-spacer></v-spacer>

            <v-alert :value="error" type="error" transition="scale-transition">
                {{ errorMessage }}

                <v-btn small flat icon color="white" @click="closeAlert">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>

            </v-alert>

        </v-toolbar>

        <v-card flat>
            <v-card-title>
                <p class="font-weight-bold subheading congatec-gray">{{ getSettingTypeHeader }}</p>
            </v-card-title>
            <v-data-table :headers="headers"
                          :items="settings"
                          :search="search"
                          hide-actions>
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left width-setting-key">{{ props.item.key }}</td>
                    <td class="text-xs-left width-setting-value">{{ props.item.value }}</td>
                    <td class="text-xs-left width-setting-description">{{props.item.description}}</td>
                    <td class="text-xs-left">
                        <v-btn color="green" dark small @click="onEdit(props.item)">
                            <v-icon v-if="updateSetting" class="mr-2">edit</v-icon>
                            <v-icon v-else class="mr-2">far fa-eye</v-icon>
                        </v-btn>

                        <v-btn color="red" dark small @click="onDelete(props.item)" v-if="deleteSetting">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>

        <v-toolbar flat color="white" style="height: 0px">
            <ConfirmSettingDeletionModal v-model="showConfirmSettingDeletionModal" :setting="setting"
                                         :systemSetting="systemSetting"
                                         :isSystemSetting="isSystemSetting"/>

            <ShowSettingModal v-model="showSettingModal" :editMode="editMode" :disabled="disabled"
                              :setting="setting"/>
            <ShowSystemSettingModal v-model="showSystemSettingModal" :editMode="editMode" :disabled="disabled"
                                    :systemSetting="systemSetting"/>
        </v-toolbar>
    </div>

</template>


<script>

    import ShowSettingModal from './modals/ShowSettingModal.vue'
    import ShowSystemSettingModal from "./modals/ShowSystemSettingModal";
    import ConfirmSettingDeletionModal from "./modals/ConfirmSettingDeletionModal"
    import settinginterface from "../../interfaces/settinginterface";
    import systemsettinginterface from "../../interfaces/systemsettinginterface";
    import {EventBus} from "../../eventbus";
    import errormessagemanager from "../../managers/errormessagemanager";


    export default {
        name: "SettingList",

        components: {
            ConfirmSettingDeletionModal,
            ShowSettingModal,
            ShowSystemSettingModal
        },

        props: {
            search: String,

            isSystemSetting: Boolean,
            deleteSetting: Boolean,
            updateSetting: Boolean
        },

        data: () => ({
            headers: [
                {text: 'Key', value: 'key'},
                {text: 'Value', value: 'value'},
                {text: 'Description', value: 'description'},
                {text: 'Options', value: 'options'}
            ],

            settings: [],

            setting: {
                settingId: null,
                key: null,
                value: null,
                description: null
            },

            emptySetting: {
                settingId: null,
                key: null,
                value: null,
                description: null
            },

            systemSetting: {
                systemSettingId: null,
                key: null,
                value: null,
                description: null
            },

            emptySystemSetting: {
                systemSettingId: null,
                key: null,
                value: null,
                description: null
            },

            error: false,
            errorMessage: null,

            showConfirmSettingDeletionModal: false,
            showSettingModal: false,
            showSystemSettingModal: false,
            editMode: false,
            disabled: false
        }),

        created() {
            this.initialize();
        },

        mounted() {
            if (this.isSystemSetting) {
                EventBus.$on('refreshSystemSettingList', () => {
                    this.initialize();
                });
                EventBus.$on('systemSettingModalClosed', () => {
                    this.initialize();
                    this.systemSetting = Object.assign({}, this.emptySystemSetting)
                });
                EventBus.$on('systemSettingDeletionConfirmed', () => {
                    this.initialize();
                    this.systemSetting = Object.assign({}, this.emptySystemSetting)
                });

            } else {
                EventBus.$on('refreshSettingList', () => {
                    this.initialize();
                });
                EventBus.$on('settingModalClosed', () => {
                    this.initialize();
                    this.setting = Object.assign({}, this.emptySetting)
                });
                EventBus.$on('settingDeletionConfirmed', () => {
                    this.initialize();
                    this.systemSetting = Object.assign({}, this.emptySystemSetting)
                });
            }
        },

        methods: {
            async onDelete(setting) {
                if (this.isSystemSetting) {
                    this.systemSetting = setting;
                } else {
                    this.setting = setting;
                }

                this.showConfirmSettingDeletionModal = true;
            },

            onEdit(setting) {
                if (this.isSystemSetting) {
                    this.onEditSystemSetting(setting);
                } else {
                    this.onEditSetting(setting);
                }
            },

            onEditSetting(setting) {
                let clonedSetting = {
                    settingId: setting.settingId,
                    key: setting.key,
                    value: setting.value,
                    description: setting.description
                };

                this.editMode = true;
                this.setting = Object.assign({}, clonedSetting);
                this.disabled = !this.updateSetting;

                this.showSettingModal = true;
            },

            async onDeleteSetting(setting) {
                let response = null;

                await settinginterface.deleteSetting(setting, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    const index = this.settings.indexOf(setting);
                    this.settings.splice(index, 1);
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            onEditSystemSetting(systemSetting) {
                let clonedSystemSetting = {
                    systemSettingId: systemSetting.systemSettingId,
                    key: systemSetting.key,
                    value: systemSetting.value,
                    description: systemSetting.description
                };

                this.editMode = true;
                this.systemSetting = Object.assign({}, clonedSystemSetting);
                this.disabled = !this.updateSetting;

                this.showSystemSettingModal = true;
            },

            async onDeleteSystemSetting(systemSetting) {
                let response = null;

                await systemsettinginterface.deleteSystemSetting(systemSetting, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    const index = this.settings.indexOf(systemSetting);
                    this.settings.splice(index, 1);
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            initialize() {
                if (this.isSystemSetting) {
                    systemsettinginterface.getSystemSettings(systemSettings => {
                        this.settings = systemSettings;
                    });
                } else {
                    settinginterface.getSettings(settings => {
                        this.settings = settings;
                    });
                }
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        },

        computed: {
            getSettingTypeHeader: function () {
                return this.isSystemSetting ? "System settings" : "Settings";
            }
        }
    };
</script>

<style>
    .width-setting-key {
        width: 20%
    }

    .width-setting-value {
        width: 20%
    }

    .width-setting-description {
        width: 35%;
    }
</style>


// WEBPACK FOOTER //
// src/components/settings/SettingList.vue